// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SchemaIndexListTreeMapQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type SchemaIndexListTreeMapQuery = {
  __typename?: "GraphqlQuery";
  getSchemaIndices: Array<{
    __typename?: "SchemaIndex";
    id: string;
    name: string;
    tableName: string;
    sizeBytes?: number | null;
  }>;
};

export const SchemaIndexListTreeMapDocument = gql`
  query SchemaIndexListTreeMap($databaseId: ID!) {
    getSchemaIndices(databaseId: $databaseId) {
      id
      name
      tableName
      sizeBytes
    }
  }
`;

/**
 * __useSchemaIndexListTreeMapQuery__
 *
 * To run a query within a React component, call `useSchemaIndexListTreeMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaIndexListTreeMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaIndexListTreeMapQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useSchemaIndexListTreeMapQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemaIndexListTreeMapQuery,
    SchemaIndexListTreeMapQueryVariables
  > &
    (
      | { variables: SchemaIndexListTreeMapQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SchemaIndexListTreeMapQuery,
    SchemaIndexListTreeMapQueryVariables
  >(SchemaIndexListTreeMapDocument, options);
}
export function useSchemaIndexListTreeMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemaIndexListTreeMapQuery,
    SchemaIndexListTreeMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchemaIndexListTreeMapQuery,
    SchemaIndexListTreeMapQueryVariables
  >(SchemaIndexListTreeMapDocument, options);
}
// @ts-ignore
export function useSchemaIndexListTreeMapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemaIndexListTreeMapQuery,
    SchemaIndexListTreeMapQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemaIndexListTreeMapQuery,
  SchemaIndexListTreeMapQueryVariables
>;
export function useSchemaIndexListTreeMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaIndexListTreeMapQuery,
        SchemaIndexListTreeMapQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemaIndexListTreeMapQuery | undefined,
  SchemaIndexListTreeMapQueryVariables
>;
export function useSchemaIndexListTreeMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaIndexListTreeMapQuery,
        SchemaIndexListTreeMapQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchemaIndexListTreeMapQuery,
    SchemaIndexListTreeMapQueryVariables
  >(SchemaIndexListTreeMapDocument, options);
}
export type SchemaIndexListTreeMapQueryHookResult = ReturnType<
  typeof useSchemaIndexListTreeMapQuery
>;
export type SchemaIndexListTreeMapLazyQueryHookResult = ReturnType<
  typeof useSchemaIndexListTreeMapLazyQuery
>;
export type SchemaIndexListTreeMapSuspenseQueryHookResult = ReturnType<
  typeof useSchemaIndexListTreeMapSuspenseQuery
>;
export type SchemaIndexListTreeMapQueryResult = Apollo.QueryResult<
  SchemaIndexListTreeMapQuery,
  SchemaIndexListTreeMapQueryVariables
>;
